/* global angular*/
import './style.less';
import { orderBy, isEqual, keyBy } from 'lodash';

export default function(
  filterEmployees = [],
  sharedProfiles,
  selectOne,
  csvSelect,
  csvAdditionalColumns = [],
  csvExampleData = [['john@prolaera.com'], ['jane@prolaera.com']]
) {
  return function controller($q, $stateParams, $timeout, $uibModalInstance, $log, ApiClass) {
    'ngInject';

    const vm = this;
    vm.$onInit = activate;
    vm.loaded = false;

    vm.pagination = {
      pageSize: 10,
      pageSizes: [10, 25, 50, 100]
    };

    vm.onFilter = function(stCtrl) {
      const oldFiltered = (vm.filtered || []).map(({ email }) => email);
      const newFiltered = stCtrl.getFilteredCollection().map(({ email }) => email);

      if (!isEqual(oldFiltered, newFiltered)) {
        vm.selectAllEmployees = false;
      }

      vm.filtered = stCtrl.getFilteredCollection();
    };

    vm.selectAll = () => {
      vm.filtered.forEach(user => (user.selected = vm.selectAllEmployees));
    };

    vm.selectUser = profile_uid => {
      if (selectOne) {
        vm.filtered.forEach(user => {
          if (user.selected && user.profile_uid !== profile_uid) {
            user.selected = false;
          }
        });
      }
    };

    vm.selectUsersFromCSV = users => {
      const emails = users.map(({ email }) => email);
      const emailMap = keyBy(users, 'email');

      vm.filtered.forEach(user => {
        if (emails.includes(user.email)) {
          user.selected = true;
          user.csvSelect = emailMap[user.email];
        }
      });
    };

    vm.addUsers = () => {
      vm.loaded = false;
      const users = vm.selectedEmployees.filter(({ selected }) => selected);
      $uibModalInstance.close(users);
    };

    vm.cancel = () => {
      $uibModalInstance.dismiss('cancel');
    };

    function activate() {
      vm.selectOne = !!selectOne;
      vm.csvSelect = !!csvSelect;
      vm.csvColumns = ['email', ...csvAdditionalColumns];
      vm.csvExampleData = csvExampleData;

      ApiClass.scan(
        ApiClass.usersGet,
        {},
        {},
        {
          queryParams: {
            manage: true,
            'scan:limit': 2000,
            'include:type': 'basic',
            'include:sharedProfiles': sharedProfiles
          }
        }
      )
        .then(({ items }) => {
          const selectedEmployees = items.filter(({ email }) => !filterEmployees.includes(email));
          vm.selectedEmployees = orderBy(selectedEmployees, ['last'], ['asc']);
          vm.dictEmployees = keyBy(vm.selectedEmployees, 'profile_uid');
          vm.loaded = true;
        })
        .catch(error => {
          $log.error(error);
          throw error;
        });
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/modals/employeesSearch/index.js